<!-- 监考管理 -->
<template>
  <div>
    <!-- 时间提示 -->
    <div class="mainDiv">
      <div class="box-right">
        <div class="right-title">距离考试结束还有：</div>
        <div class="right-time">
          {{ countdown.days }}天 {{ countdown.hours }} :
          {{ countdown.minutes }} : {{ countdown.seconds }}
        </div>
      </div>
      <div class="exam-time">
        考试时间：{{ examInfo.startTime | showDate }} 至
        {{ examInfo.endTime | showDate }}
      </div>
      <div style="position: relative">
        <el-tabs v-model="reviewStatus" type="card" @tab-click="toggleClick">
          <el-tab-pane
            v-for="item in reviewStatusList"
            :key="item.name"
            :label="item.label + ' （' + item.content + '）'"
            :content="item.content"
            :name="item.name"
          ></el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!-- 检索栏 -->
    <div class="tab">
      <div class="control">
        <el-form ref="form" :model="form" label-width="100px" size="mini">
          <el-row>
            <el-col :span="12">
              <el-form-item prop="fullName" label="考生姓名：">
                <el-input
                  v-model="form.fullName"
                  placeholder="-请输入学生姓名-"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="userCard" label="考生身份证：">
                <el-input
                  v-model="form.userCard"
                  placeholder="-请输入学生身份证-"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-button type="primary" size="mini" @click="search">确定</el-button>
        <el-button size="mini" @click="delAll"> 清空 </el-button>
      </div>
    </div>
    <!-- 列表 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
      @selection-change="handleSelectionChange"
      @sort-change="sortChange"
    >
      <!-- <el-table-column type="selection" width="50" align="center"> 
      </el-table-column> -->
      <el-table-column
        width="50"
        prop="rowNum"
        label="ID"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="batchCode"
        label="批次号/班级编码"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="albumTitle"
        label="班级名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="rkTeacherName"
        label="任课老师"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="rkMhmName"
        label="任课机构"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="uname"
        label="用户名"
        align="center"
      ></el-table-column>
      <el-table-column prop="fullName" label="考生姓名" align="center">
      </el-table-column>
      <el-table-column
        prop="userCard"
        label="身份证号"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="signStatus"
        label="签到状态"
        width="90"
        align="center"
        header-align="center"
      ></el-table-column>

      <el-table-column
        prop="userPhoto"
        label=" 人脸抓拍验证照片"
        width="90"
        align="center"
        header-align="center"
        v-if="examsPaperStatus == 1 || examsPaperStatus == 0"
      >
        <template slot-scope="scope">
          <img class="photo" :src="scope.row.userPhoto" alt="" />
        </template>
      </el-table-column>
      <el-table-column
        prop="tourStatus"
        label="巡考状态"
        width="90"
        align="center"
        header-align="center"
        v-if="examsPaperStatus == 1 || examsPaperStatus == 0"
      ></el-table-column>
      <el-table-column
        prop="scoreStatus"
        label="巡考结果"
        width="90"
        align="center"
        header-align="center"
        v-if="examsPaperStatus == 1 || examsPaperStatus == 0"
      ></el-table-column>

      <el-table-column
        prop="uname"
        label="操作"
        width="200"
        align="center"
        v-if="examsPaperStatus == 1 || examsPaperStatus == 0"
      >
        <template slot-scope="scope">
          <div class="table_control">
            <span
              class="table_control_item"
              v-if="examsPaperStatus == 0"
              @click="
                tourExam('1', scope.row.examsUsersId, scope.row.courseName)
              "
              >巡考</span
            >

            <span
              class="operation"
              v-if="examsPaperStatus == 0"
              @click="
                readMonitor(
                  scope.row.examsUsersId,
                  scope.row.fullName,
                  scope.row.admissionCard
                )
              "
              >查看监控照片</span
            >

            <span
              v-if="examsPaperStatus == 1"
              class="table_control_item"
              @click="
                reviewToDetermine(
                  '2',
                  scope.row.examsUsersId,
                  scope.row.courseName,
                  scope.row.id
                )
              "
              >审核确定</span
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      width="60%"
      title="查看监控照片"
      :visible.sync="showScreenShotList"
    >
      <div class="header">
        <div class="header-left">
          <span class="name">姓名 : {{ screenShotName }}</span>
          <span>准考证号 : {{ screenShotAdmissionCard }}</span>
        </div>
        <div class="header-right">
          要求识别率：70% / 当前识别率：<span style="color: red"
            >{{ passRate }}%</span
          >
        </div>
      </div>
      <div class="record-info">
        当前已抓拍{{
          screenShotList.length
        }}张考生考试过程中的人脸照片，识别通过{{ passCount }}张，不通过<span
          style="color: red"
          >{{ screenShotList.length - passCount }}</span
        >张
      </div>
      <div class="record-list">
        <p style="padding: 5px">识别通过（{{ passCount }}）</p>
        <div class="record-img-ul">
          <div
            v-for="(item, index) in screenShotList"
            :key="index"
            class="record-img-li"
          >
            <div class="record-img-li-lv">
              识别率：{{ item.discriminateRate }}%
            </div>
            <img :src="url + item.fileName" alt="" />
            <div class="record-img-li-bottom">
              <div v-if="item.status == 0">正常</div>
              <div v-if="item.status == 1">异常</div>
              <div>{{ item.createTime | showDate2 }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import * as api from "@/api/ExamManagement/ComprehensiveTestDetail/examArrangement";
import * as api2 from "@/api/invigilate/invigilateList";
import { formatDate, setHost } from "@/utils/common";
export default {
  data() {
    return {
      // 检索数据
      form: {
        fullName: "",
        userCard: "",
      },
      title: "你好",
      // 二级菜单
      reviewStatusList: [
        { content: "0", label: "考试进行中", name: "0" },
        { content: "0", label: "已完成考试", name: "1" },
        { content: "0", label: "未开始考试", name: "2" },
      ],
      reviewStatus: "0",
      // 倒计时数据
      countdown: {
        days: "",
        hours: "",
        minutes: "",
        seconds: "",
        pageTimer: {},
      },
      // 获取时间参数
      batchId: this.$route.query.batchId,
      uid: localStorage.getItem("uid"),
      courseId: this.$route.query.courseId,
      elExamsPaperId: this.$route.query.examsPaperId,
      examInfo: {
        startTime: "",
        endTime: "",
      },
      // 考试状态
      examsPaperStatus: 0,

      tableData: [],
      // 分页
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      // 总数
      total: 0,
      selectedList: [],
      // 查看巡考照片
      screenShotName: "",
      screenShotAdmissionCard: "",
      screenShotList: [],
      passCount: "",
      showScreenShotList: false,
      vid:this.$route.query.vid
    };
  },
  filters: {
    // 时间格式化
    showDate(value) {
      let date = new Date(value * 1000);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
    // 时间格式化
    showDate2(value) {
      let date = new Date(value * 1000);
      return formatDate(date, "mm:ss");
    },
    // 时间格式化
    showDate3(value) {
      let hour = 0;
      let min = 0;
      let sec = 0;
      hour = Math.floor((value / 60 / 60) % 60);
      min = Math.floor((value / 60) % 60);
      sec = Math.floor(value % 60);
      hour = hour < 10 ? "0" + hour : hour;
      min = min < 10 ? "0" + min : min;
      sec = sec < 10 ? "0" + sec : sec;
      return hour + ":" + min + ":" + sec;
    },
  },
  computed: {
    passRate: function () {
      const passCount = this.passCount;
      const allCount = Number(this.screenShotList.length);
      if (passCount === 0 || allCount === 0) return 0;
      const rate = ((passCount / allCount) * 100).toFixed(2);
      return rate;
    },
    getUId() {
      return localStorage.getItem("uid");
    },
    url() {
      let url = window.location.protocol + "//" + window.location.host;
      if (window.location.host == "localhost:5001") {
        url = "http://gz.hnjk.net";
      }
      if (window.location.host == "fxl.sce.scut.edu.cn") {
        url = url + "/zk";
      }
      return url;
    },
  },
  created() {
    if (this.$route.query.status == "考试中") {
      this.examsPaperStatus = 0;
      this.reviewStatus = "0";
    } else if (this.$route.query.status == "未考试") {
      this.examsPaperStatus = 1;
      this.reviewStatus = "1";
    } else {
      this.examsPaperStatus = 2;
      this.reviewStatus = "2";
    }

    this.getExamsTestList();
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this.enterQuery);
  },
  mounted() {
    this.batchId = this.$route.query.batchId;
    this.elExamsPaperId = this.$route.query.examsPaperId;
    this.courseName = this.$route.query.courseName;
    this.vid = this.$route.query.vid;
    this.examsPaperTitle = this.$route.query.examsPaperTitle;
    this.host = setHost();
    // this.getData()
    this.getExamInfo();
  },
  methods: {
    // 时间接口
    getExamInfo() {
      let that = this;
      let reqdata = {
        elExamsPaperId: this.elExamsPaperId,
        batchId: this.$route.query.batchId,
        teacherCourseBatchId: this.$route.query.teacherCourseBatchId,
      };
      api.getExamsPaperById(reqdata).then(({ data }) => {
        if (data.code == 100000) {
          console.log("时间参数", data);
          that.examInfo.endTime = data.data.endTime;
          that.examInfo.startTime = data.data.startTime;
          that.examInfo.examsPaperTitle = data.data.examsPaperTitle;
          that.setCountdown(data.data.endTime); //开始倒计时
        } else {
          that.$message.error(data.msg);
        }
      });
    },
    async getExamsTestList() {
      const { data, code } = (
        await api.getExamsTestList({
          batchId: this.$route.query.batchId,
          uid: localStorage.getItem("uid"),
          // 试卷id
          examsPaperId: this.$route.query.examsPaperId,
          teacherCourseBatchId:this.$route.query.teacherCourseBatchId,
          // 考试状态
          examsPaperStatus: this.examsPaperStatus,
          ...this.form,
          ...this.pageObj,
        })
      ).data;
      if (code === 100000) {
        console.log("考试状态参数", data);
        this.reviewStatusList.forEach((v) => {
          if (v.name == "0") {
            v.content = data.examingNum;
          } else if (v.name == "1") {
            v.content = data.finishExamNum;
          } else {
            v.content = data.notExamNum;
          }
        });

        this.tableData = data.examsUsers.list;
        this.tableData.forEach((v) => {
          // 巡考状态tourStatus【0:未巡考 1:已通过 2:未通过】
          if (v.tourStatus == 0) {
            v.tourStatus = "未巡考";
          } else if (v.tourStatus == 1) {
            v.tourStatus = "已通过";
          } else {
            v.tourStatus = "未通过";
          }
          // 巡考结果scoreStatus   0:待审核 1:成绩有效 2:成绩无效
          if (v.scoreStatus == 0) {
            v.scoreStatus = "待审核";
          } else if (v.scoreStatus == 1) {
            v.scoreStatus = "成绩有效";
          } else {
            v.scoreStatus = "成绩无效";
          }
        });
        this.total = data.examsUsers.total;
      }
    },
    // 巡考
    tourExam(tab, examsUsersId) {
      this.$router.push(
        `/InvigilateDetails?tab=${tab}&exams_users_id=${examsUsersId}&examinerId=${this.uid}`
      );
    },
    // 查看监控照片
    readMonitor(examsUsersId, fullName, admissionCard) {
      this.screenShotName = fullName;
      this.screenShotAdmissionCard = admissionCard;
      let reqdata = {
        examsUsersId: examsUsersId,
        type: "0",
        status: "",
      };
      api2.getScreenShotList(reqdata).then(({ data }) => {
        if (data.code == 100000) {
          this.screenShotList = data.data;
          this.showScreenShotList = true;
          let passCount = 0;
          //计算通过抓拍的张数
          for (let item of data.data) {
            if (item.status == 0) {
              passCount++;
            }
          }
          this.passCount = passCount;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    // 二级切换查询数据
    tabChange(tab) {
      if (tab.name === this.type) return;
      console.log("tab==>", tab.name);
    },
    // 倒计时处理
    setCountdown(timestamp, oldtime) {
      console.log(timestamp);
      let self = this;
      this.countdown.pageTimer["timer1"] = setInterval(function () {
        let nowTime = new Date();
        let endTime = new Date(timestamp * 1000);
        let t = endTime.getTime() - nowTime.getTime();
        if (t > 0) {
          let day = Math.floor(t / 86400000);
          let hour = Math.floor((t / 3600000) % 24);
          let min = Math.floor((t / 60000) % 60);
          let sec = Math.floor((t / 1000) % 60);
          hour = hour < 10 ? "0" + hour : hour;
          min = min < 10 ? "0" + min : min;
          sec = sec < 10 ? "0" + sec : sec;
          self.countdown.days = day;
          self.countdown.hours = hour;
          self.countdown.minutes = min;
          self.countdown.seconds = sec;
          let millSeconds = 9;
          self.countdown.pageTimer["timer2"] = setInterval(function () {
            self.countdown.milliseconds = millSeconds;
            millSeconds--;
            if (millSeconds < 0) {
              millSeconds = 9;
            }
          }, 100);
        } else {
          clearInterval(self.countdown.pageTimer["timer1"]);
          self.countdown.hours = 0;
          self.countdown.minutes = 0;
          self.countdown.seconds = 0;
          self.countdown.milliseconds = 0;
          self._callback();
        }
      }, 1000);
    },
    // 审核确定
    reviewToDetermine(tab, examsPaperId) {
      this.$router.push(
        // E:\zzy\zkweb\src\views\invigilate\InvigilateExamine.vue
        `/InvigilateExamine?tab=${tab}&exams_users_id=${examsPaperId}&batchId=${this.batchId}&examsPaperId=${this.elExamsPaperId}&courseName=${this.courseName}&examsPaperTitle=${this.examsPaperTitle}&vid=${this.vid}`
      );
    },
    enterQuery(e) {
      if (e.key === "Enter") {
      }
    },
    //搜索
    search() {
      this.pageObj.page = 1;
      this.getExamsTestList();
      this.isSeach = true;
    },
    //清空搜索内容
    delAll() {
      (this.form.fullName = ""),
        (this.form.userCard = ""),
        (this.pageObj.page = 1);
      this.getExamsTestList();
    },

    addStudents() {
      this.$emit("addStudents");
    },
    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val;
      this.getExamsTestList();
    },
    // 点击切换
    toggleClick(e) {
      console.log(e.$attrs.content);
      if (e.index == "0") {
        this.examsPaperStatus = 0;
        this.getExamsTestList();
      } else if (e.index == "1") {
        this.examsPaperStatus = 1;
        this.getExamsTestList();
      } else {
        this.examsPaperStatus = 2;
        this.getExamsTestList();
      }
      // 可以通过uid来判断点击的哪个来切换表格数据
    },
    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val;
      this.getExamsTestList();
    },
    visibleChange(e) {
      if (!e) {
        this.$refs.applyTypeSelect.blur();
      }
    },
    // 处理选中事件
    handleSelectionChange(arr) {
      this.selectedList = arr;
    },
    goLearningOutcome() {
      this.$emit("goLearningOutcomeFromStudent");
    },
    sortChange({ column, prop, order }) {},
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/classManagement.scss";
.table_control {
  color: #409eff;
  .table_control_item {
    margin-right: 10px;
    cursor: pointer;
  }
}
.exam-time {
  height: 30px;
  // z-index: 999;
  // color: black;
  font-size: 16px;
  color: #d9001b;
  padding-left: 20px;
  font-weight: 600;
}
/deep/.mainDiv {
  padding-bottom: 0;
  padding-top: 0;
  padding-left: 0;
  position: relative;
  top: -20px;
}
.box-right {
  background-color: #ed5900;
  height: 60px;
  width: 154px;
  position: absolute;
  right: 0px;
}
.right-title {
  font-size: 16px;
  text-align: center;
  color: white;
  margin: 6px 0;
}
.right-time {
  font-size: 14px;
  text-align: center;
  color: white;
}
.photo {
  width: 60px;
  height: 60px;
}
</style>
